import * as types from "./mutation_types"

export default {
    [types.FAQ_LIST] (state:any,data=[]) {
        state.faqList = data
    },
}
